import type { guide as guideEn } from '../en/guide';

export const guide: typeof guideEn = {
  title: 'Guía',
  subtitle: 'Su manual para las primeras semanas',

  expect: {
    section: 'Qué esperar',
    tableTitle: 'Día por día',
    tableCaption: 'Mínimos diarios de pañales mojados y sucios, y cantidades típicas por toma.',
    colDay: 'Día',
    colWet: 'Mojados',
    colStool: 'Sucios',
    colIntake: 'Por toma',
    dayPlus: (day: number) => `${day}+`,
    atLeast: (n: number) => `${n}+`,
    range: (min: string, max: string) => `${min} a ${max}`,
  },

  visits: {
    section: 'Su plan de visitas',
  },

  reach: {
    call: (phone: string) => `Llamar al ${phone}`,
    text: (phone: string) => `Enviar texto al ${phone}`,
  },

  mood: {
    crisisTitle: 'Si necesita ayuda ahora mismo',
    call988: 'Llamar al 988',
    text988: 'Texto al 988',
    callPsi: 'Llamar a PSI: 1-800-944-4773',
  },
};
